import Vue from 'vue'
import '@js/htmlFontSize.js';
import App from './App.vue'
import router from './router/login'
import store from './store'
import axios from './common/httpRequest';
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/css/swiper.css'
// Vue.use(VueAwesomeSwiper)
Vue.use(VueAwesomeSwiper, /* { default global options } */); // eslint-disable-line

Vue.prototype.$http = axios;
// 导入极验
require('@/common/gt.js');
// 绑定到原型
Vue.prototype.$initGeet = window.initGeetest;

Vue.config.productionTip = false
Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    // 聚焦元素
    el.focus()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
